import styled from 'styled-components'

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 3rem;

  & > button:not(:first-child) {
    margin-left: 3rem;
  }
`
